import {CheckStatusDialog, useCommitChecksStatusDetails} from '@github-ui/commit-checks-status'
import {Link} from '@primer/react'
import {useRef, useState, type ReactNode} from 'react'
import {useLayoutBaseRepository} from '../../../../stores/selectors'

export function CommitChecksLink({commitOid, children}: {commitOid: string; children: ReactNode}) {
  const repo = useLayoutBaseRepository()
  const linkRef = useRef<HTMLButtonElement>(null)
  const [isOpen, setIsOpen] = useState(false)
  const [details, fetchDetails] = useCommitChecksStatusDetails(commitOid, repo, {isDialogOpen: isOpen})

  return (
    <>
      <Link
        ref={linkRef}
        as="button"
        inline
        onClick={() => {
          setIsOpen(true)
          // The checks behind these events are historical, so reuse the first result on reopen
          if (!details) fetchDetails()
        }}
      >
        {children}
      </Link>
      {isOpen && (
        <CheckStatusDialog
          combinedStatus={details}
          isOpen={isOpen}
          repositoryNwo={`${repo.ownerLogin}/${repo.name}`}
          onDismiss={() => setIsOpen(false)}
          returnFocusRef={linkRef}
        />
      )}
    </>
  )
}
